import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { BillingType } from './useCompanies';

export type CreateCompanyInput = {
  name: string;
  fca_firm_reference_number?: string;
  billing_type?: BillingType | null;
  billing_amount?: number | null;
  website?: string | null;
};

export const useCreateCompanyMutation = () => {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
  } = useMutation<{ data: unknown }, Error, CreateCompanyInput>({
    mutationFn: (input: CreateCompanyInput) => api.post('admin/companies', input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'companies'] });
    },
  });

  const createCompany = async (input: CreateCompanyInput) => {
    await mutateAsync(input);
  };

  return {
    createCompany,
    isLoading,
    error,
  };
};
